import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./routes/home/home-page').then((m) => m.HomePage),
  },
  {
    path: 'report',
    loadComponent: () =>
      import('./routes/report/report-page').then((m) => m.ReportPage),
  },
  {
    path: 'success',
    loadComponent: () =>
      import('./routes/success/success-page').then((m) => m.SuccessPage),
  },
];
